import { render } from "./add-member.vue?vue&type=template&id=45fd0c7a&scoped=true"
import script from "./add-member.vue?vue&type=script&lang=js"
export * from "./add-member.vue?vue&type=script&lang=js"

import "@/resources/css/settings.scss?vue&type=style&index=0&id=45fd0c7a&lang=scss&scoped=true&external"
import "./add-member.vue?vue&type=style&index=1&id=45fd0c7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fd0c7a"]])

export default __exports__